export default class G {
  constructor(t = !1, s = []) {
    (this.tt = t), (this.$e = s), (this.tt = t), (this.$e = s);
  }
  _t(t) {
    (this.tt = this.tt && t.tt), this.$e.push(...t.$e);
  }
}
